import React from "react";
import { useNavigate } from "react-router-dom";
import Router from "../Router";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[100dvh] bg-gradient-to-b from-green-300 to-green-500 flex flex-col items-center justify-center p-6">
      <h1 className="text-6xl font-bold text-white">404</h1>
      <p className="text-2xl text-white mt-4">
        Oops! The page you are looking for does not exist.
      </p>
      <button
        onClick={() => navigate("/")}
        className="mt-6 px-6 py-3 bg-white text-green-600 font-semibold rounded shadow hover:bg-gray-200 transition duration-200"
      >
        Go Home
      </button>
    </div>
  );
};

export default Router(PageNotFound);